import { render, staticRenderFns } from "./HotelPreviewCard.vue?vue&type=template&id=c2e12020"
import script from "./HotelPreviewCard.vue?vue&type=script&lang=js"
export * from "./HotelPreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports